import script from "./SplitPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitPopup.vue?vue&type=script&setup=true&lang=ts"

import "./SplitPopup.vue?vue&type=style&index=0&id=19fed94e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fed94e"]])

export default __exports__